import { useId } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@shared/components';
import type { Dealer } from '@/features/dealers/types/dealers.types';
import { formatAddress } from '../../utils/formatAddress';
import { SummaryDetailList } from './SummaryDetailList';

interface Props {
    dealer: Dealer;
}

export function QuoteDealerPanel({ dealer }: Props) {
    const headingId = useId();

    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <span id={headingId}>Selling dealer</span>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <section aria-labelledby={headingId}>
                    <SummaryDetailList
                        emptyMessage="No selling dealer details are recorded."
                        fields={[
                            { label: 'Name', value: dealer.name || undefined },
                            { label: 'Address', value: formatAddress(dealer) },
                            { label: 'Phone', value: dealer.phone || undefined },
                            { label: 'Email', value: dealer.email || undefined },
                        ]}
                    />
                </section>
            </CardContent>
        </Card>
    );
}
